/** Six weeks of complete Central days: through yesterday, never the partial current day. */
export function completeDayRange(now = new Date()) {
  const today = now.toLocaleDateString('en-CA', { timeZone: 'America/Chicago' });
  const [year, month, day] = today.split('-').map(Number);
  const offset = (days: number) => new Date(Date.UTC(year, month - 1, day - days)).toISOString().slice(0, 10);
  return { start: offset(42), end: offset(1) };
}
